import Actions from '../constants/Actions';

export async function learnMoreAboutPage(context, path) {

  context.dispatch(Actions.HELP_VIDEO__QUERY_STARTED);

  let learnMoreVideo;
  try {
    ({ data: learnMoreVideo } = await context.service.read('learnMore', {pagePath: path}));
  } catch (err) {
    context.dispatch(Actions.HELP_VIDEO__QUERY_FAILED, err);
  }
  if (learnMoreVideo !== undefined) {
    context.dispatch(Actions.HELP_VIDEO__QUERY_COMPLETED, learnMoreVideo);
  }

}



// WEBPACK FOOTER //
// ./src/actions/LearnMoreActionCreators.js